import { Control, useController } from "react-hook-form"
import { observer } from "mobx-react-lite"
import { MultiSelectInput } from "../MultiSelectInput"

type SelectOption = { value: string; label: string }
type OptionsArray = SelectOption[]
type NestedOptions = { label: string; options: OptionsArray }[]

interface FormMultiSelectInputProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  name: string
  placeholder?: string
  options: OptionsArray | NestedOptions
  label: string
  handleChange?: (value?: string[], label?: string[]) => void
  handlePopoverChange?: (visible: boolean) => void
  isLoading?: boolean
  testID?: string
  searchLabel?: string
  textValue?: string
  darkTheme?: boolean
  parentBackgroundColor: string
  lightOutline?: boolean
}

export const FormMultiSelectInput = observer(
  ({
    control,
    name,
    options = [],
    label,
    searchLabel,
    textValue = "",
    handleChange,
    handlePopoverChange,
    isLoading = false,
    testID,
    darkTheme = false,
    parentBackgroundColor,
    lightOutline,
  }: FormMultiSelectInputProps) => {
    const {
      field: { onChange, value },
    } = useController({ name, control })

    return (
      <MultiSelectInput
        value={value}
        onChange={onChange}
        options={options}
        label={label}
        textValue={textValue}
        handleChange={handleChange}
        handlePopoverChange={handlePopoverChange}
        isLoading={isLoading}
        testID={testID}
        darkTheme={darkTheme}
        searchLabel={searchLabel || label}
        name={name}
        parentBackgroundColor={parentBackgroundColor}
        lightOutline={lightOutline}
      />
    )
  },
)
